// base dropdown events
export const GL_DROPDOWN_SHOWN = 'shown';
export const GL_DROPDOWN_HIDDEN = 'hidden';
export const GL_DROPDOWN_BEFORE_CLOSE = 'beforeClose';
export const GL_DROPDOWN_FOCUS_CONTENT = 'focusContent';

// KeyboardEvent.code values
export const ARROW_DOWN = 'ArrowDown';
export const ARROW_UP = 'ArrowUp';
export const END = 'End';
export const ENTER = 'Enter';
export const HOME = 'Home';
export const SPACE = 'Space';

// KeyboardEvent.keyCode values
export const KEY_CODE_ESCAPE = 27;

// Positioning strategies
// https://floating-ui.com/docs/computePosition#strategy
export const POSITION_ABSOLUTE = 'absolute';
export const POSITION_FIXED = 'fixed';

export const GL_DROPDOWN_CONTENTS_CLASS = 'gl-new-dropdown-contents';
